export function registerPwa() {
  if (!('serviceWorker' in navigator) || process.env.NODE_ENV !== 'production') return;
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      const announce = () => {
        if (registration.waiting) {
          window.dispatchEvent(new CustomEvent('quod:pwa-update', { detail: registration }));
        }
      };
      announce();
      registration.addEventListener('updatefound', () => {
        const installing = registration.installing;
        installing?.addEventListener('statechange', () => {
          if (installing.state === 'installed' && navigator.serviceWorker.controller) announce();
        });
      });
    } catch (_) {
      // Installation is an enhancement; Finder remains a network-first web app.
    }
  });
}
